const login = r => require.ensure([], () => r(require('@/page/login')), 'login');

export default [
  {
    path: '/',
    name: 'login',
    component: login
  }
];



// WEBPACK FOOTER //
// ./src/router/login.js